module.exports = __webpack_public_path__ + "img/lillian.fa1d06d2.jpg";